var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[(_vm.$slots.header)?_c('el-header',{staticStyle:{"padding":"0px","height":"70px"}},[_c('div',{staticClass:"innerTopNav"},[_vm._t("header")],2)]):_vm._e(),_c('el-main',{style:({
			padding: _vm.pagePadding,
			height: _vm.$slots.header ? 'calc(100vh - 140px)' : 'calc(100vh - 70px)',
			backgroundColor: '#fdfcff',
			overflowY: 'hidden',
		})},[_c('div',{staticClass:"pageContents",style:({ padding: _vm.pagePadding, height: `calc(100% - ${_vm.pagePadding})` })},[_vm._t("page")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }